export function defaultY(d) {
  return d[1];
}

export default function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-quadtree/src/y.js
// module id = 633
// module chunks = 0